<template>
  <div id="app">
    <v-app id="inspire">
      <Header
        title="RA2S - Serviços de Telecomunicação Ltda."
        :hideToggle="!user"
        :hideUserDropdown="!user"
      />
      <v-main>
        <router-view />
      </v-main>
    </v-app>
  </div>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, userKey } from '@/global'
import { mapState } from 'vuex'
import Header from '@/components/template/Header'
export default {
  name: 'App',
  components: { Header },
  computed: mapState(['isMenuVisible', 'user']),
  data: () => ({
    drawer: null,
    validatingToken: true,
    isOnMobile: false
  }),
  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize)
  },
  methods: {
    async validateToken () {
      this.validatingToken = true
      const json = localStorage.getItem(userKey)
      const userData = JSON.parse(json)
      this.$store.commit('setUser', null)

      if (!userData) {
        this.validatingToken = false
        this.$router.push({ name: 'login' })
        return
      }

      const res = await axios.post(`${baseApiUrl}/got/validateToken`, userData)
      if (res.data) {
        this.$store.commit('setUser', userData)
        if (this.$mq === 'xs' || this.$mq === 'sm') {
          this.$store.commit('toggleMenu', false)
        }
      } else {
        localStorage.removeItem(userKey)
        this.$router.push({ name: 'login' })
      }

      this.validatingToken = false
    },
    onToggleCollapse (collapsed) {
      console.log(collapsed)
      this.collapsed = collapsed
    },
    onItemClick (event, item, node) {
      console.log('onItemClick')
      console.log(event)
      console.log(item)
      console.log(node)
    },
    onResize () {
      if (window.innerWidth <= 767) {
        this.isOnMobile = true
        this.collapsed = true
      } else {
        this.isOnMobile = false
        this.collapsed = false
      }
    }
  },
  created () {
    this.validateToken()
  }
}
</script>

<style>
.box-container {
  max-width: 1180px;
  margin: 0 auto;
  padding: 5px;
  float: none !important;
}
.tc-container {
  width: 98% !important;
  float: none !important;
}
.borda-vm {
  border: solid 1px #ac1919;
}
.borda-az {
  border: solid 1px #075ddd;
}
#app {
  background-color: #e5e5e5;
}
.btn-append {
  margin-top: -7px !important;
  width: 30px !important;
  height: 30px !important;
}
.text-height {
  height: 45px !important;
  padding: 0px !important;
}
.icon-btn {
  width: 15px !important;
  margin: 1px !important;
  border: solid 1px #1fec0d;
}
</style>
